import React, { useState } from "react";
import { Paper } from "@material-ui/core";
import ImageAttachment from "../../biztran_controls/ImageAttachment";
import CreateAttachments from "../../crm/Activities/CreateAttachments";
import ProductCategoryTV from "./ProductCategoryTV";
import AddCategory from "./AddCategory";
import ModalFrame from "../../biztran_controls/Modal_Frame";

const RelatedView = (props) => {
    const [isOpen, setOpen] = useState(false);
    const [DeleteDisplay,setDeleteDisplay] = useState('none');
    const [CatName,setCatName] = useState('');
    const [CatID,setCatID] = useState('');
    const [Mode, setMode] = useState('');

    const AddNewCategory = () => {
      setCatName('1');
      setCatID('');
      setMode('Insert');
      setDeleteDisplay('none');
      setOpen(true);
    }
  
    const onAddCat2 = (cat1ID) => {
      setCatID(cat1ID);
      setCatName('2');
      setDeleteDisplay('none');
      setMode('Insert');
      setOpen(true);
    };
  
    const onAddCat3 = (cat2ID) => {
      setCatID(cat2ID);
      setCatName('3');
      setDeleteDisplay('none');
      setMode('Insert');
      setOpen(true);
    };
  
    const onAddCat4 = (cat3ID) => {
      setCatID(cat3ID);
      setCatName('4');
      setDeleteDisplay('none');
      setMode('Insert');
      setOpen(true);
    };
  
    const onEditCat1 = (cat1ID) => {
      setCatID(cat1ID);
      setCatName('1');
      setDeleteDisplay('flex');
      setMode('Update');
      setOpen(true);
    };
  
    const onEditCat2 = (cat2ID) => {
      setCatID(cat2ID);
      setCatName('2');
      setDeleteDisplay('flex');
      setMode('Update');
      setOpen(true);
    };
  
    const onEditCat3 = (cat3ID) => {
      setCatID(cat3ID);
      setCatName('3');
      setDeleteDisplay('flex');
      setMode('Update');
      setOpen(true);
    };
  
    const onEditCat4 = (cat4ID) => {
      setCatID(cat4ID);
      setCatName('4');
      setDeleteDisplay('flex');
      setMode('Update');
      setOpen(true);
    };

    return <div>
        <Paper style={{ border: "0.1rem solid gray" }}>
            <ImageAttachment 
              id="product-image-button" 
              Group="Product" 
              Type="Image" 
              RefDocumentID={props.ProductID}
            />
            <Paper
              style={{ border: "0.1rem solid gray", height: 150, margin: 7,overflow:"scroll",overflowX:"hidden" }}
            >
              <a href="javascript:;" onClick={() => { AddNewCategory(); }} >Add Category</a>
              <ProductCategoryTV
                ProductID={props.ProductID}
                ProductName={props.ProductName}
                // onCatClick={onItemClick}
                onAddCat2={onAddCat2}
                onAddCat3={onAddCat3}
                onAddCat4={onAddCat4}
                onEditCat1={onEditCat1}
                onEditCat2={onEditCat2}
                onEditCat3={onEditCat3}
                onEditCat4={onEditCat4}
                CatData={props.ProductCat}
              />
            </Paper>
            <Paper style={{ border: "0.1rem solid gray", height: 150, margin: 7 }} elevation={3}>
              <CreateAttachments RefDocumentID={props.ProductID} Group="Product" />
            </Paper>
        </Paper>
        <ModalFrame
            title = "Category Details"
            maxWidth="xs"
            isOpen={isOpen}
            headerAlign="center"
            setOpen={setOpen}
        >
            <AddCategory
              ProductID= {props.ProductID}
              ProductName={props.ProductName}
              CatName={CatName}
              CatID={CatID}
              DeleteDisplay={DeleteDisplay}
              CatData={props.ProductCat}
              Mode={Mode}
              getProductViewData={props.getProductViewData}
              setOpen={setOpen}
            />
        </ModalFrame>
    </div>
}

export default RelatedView;
